import React, { useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { isEmpty, PAGE_SIZE } from '../../helper'
import { useParams } from 'react-router'
import useAxios from 'axios-hooks'
import ContentListComponent from './contentListComponent'
import { CONTENT_FILTERING, CONTENT_FILTERING_V2 } from '../../apiUrls'
import { AppContext } from '../../context/app'

let totalRecords = 0
let currentPage = 1
let apiHit = false
const ContentListing = () => {
  const title = useParams().filterName
  const [searchParams] = useSearchParams()
  const isFilterV2 = searchParams.get('filterV2') === 'true'
  const { setLoader } = useContext(AppContext)
  const [dataList, setDataList] = useState([])

  const [{ data: contentList, loading: contentListLoading }, contentFilterCall] = useAxios(
    {
      url: isFilterV2 ? CONTENT_FILTERING_V2 : CONTENT_FILTERING,
      method: 'post',
    },
    { manual: true },
  )

  const hitAPI = (page) => {
    const filters = searchParams.get('filters')
    if (!isEmpty(filters)) {
      const payload = JSON.parse(atob(filters))
      payload['page_size'] = PAGE_SIZE
      payload['page'] = page
      apiHit = true
      contentFilterCall({
        data: payload,
      })
    }
  }

  useEffect(() => {
    hitAPI(1)
    currentPage = 1
    setDataList([])
    totalRecords = 0
  }, [title])

  useEffect(() => {
    if (contentList && contentList.success) {
      setDataList((dataList) => [...dataList, ...contentList.data])
      totalRecords = contentList.total
      apiHit = false
    }
  }, [contentList])

  useEffect(() => {
    setLoader(contentListLoading)
  }, [contentListLoading])

  useEffect(() => {
    window.addEventListener('scroll', infiniteScroll)
    return function cleanupListener() {
      window.removeEventListener('scroll', infiniteScroll)
    }
  }, [title])

  const infiniteScroll = () => {
    // End of the document reached?
    if (
      window.innerHeight + document.documentElement.scrollTop >
      0.7 * document.documentElement.offsetHeight
    ) {
      if (!apiHit && totalRecords > currentPage * PAGE_SIZE) {
        apiHit = true
        currentPage += 1
        hitAPI(currentPage)
      }
    }
  }

  return <ContentListComponent title={title} data={dataList} />
}

export default ContentListing
